const types = {
  EMAIL_US_MODAL: 'EMAIL_US_MODAL',
  STOCK_TICKER: 'STOCK_TICKER',
};
export default types;
